export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// /home/homechange/domains/homechange.plug-in.es/public_html/wp-content/themes/templatePLG/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = 25
// module chunks = 0